<template lang="pug">
div
  .vip-button-new-container(:class='classes' v-if="unOpenShowCanBuy")
    .trans-tab
      .tab-options
        .options-item(
          :class="[actived === ZeroMoney ? 'isActived' : '']"
          @click="optionChange(ZeroMoney)"
        )
          .item-left {{ currentRideCard.remainDays }}天
            span(:class="[actived === ZeroMoney ? 'red' : '']") ¥
          .item-right(:class="[actived === ZeroMoney ? 'red' : '']") 0
        .options-item(
          :class="[actived === ContinuousMonth ? 'isActived' : '']"
          @click="optionChange(ContinuousMonth)"
        )
          .item-left 连续包月
            span(:class="[actived === ContinuousMonth ? 'red' : '']") ¥
          .item-right(
            :class="[actived === ContinuousMonth ? 'red' : '']"
          ) {{info.signInfoDTO?info.signInfoDTO.firstSignPrice:'-'}}
        .options-item(
          :class="[actived === OneMonth ? 'isActived' : '']"
          @click="optionChange(OneMonth)"
        )
          .item-left 1个月
            span(:class="[actived === OneMonth ? 'red' : '']") ¥
          .item-right(:class="[actived === OneMonth ? 'red' : '']") {{info.current*1||'-'}}
      .remarkContent
        span 到期¥
        span {{ info.signInfoDTO?info.signInfoDTO.secondSignPrice:'-'}}
        span 自动续期
        span.font-black 随心骑会员（含30天单车不限次卡）
        span ，可关闭
      .buy-button(@click="buy(1,true)")
        .btn-left {{ activedMoney }}元{{ actived === 1 ? "体验" : "立即开通" }}
        .btn-right ¥{{info.original*1}}
      .renewal-rules
        div(style="display:flex")
          div(v-if="isNoSign" @click="sign")
            img.rule-word-img(src="https://m.hellobike.com/resource/helloyun/08345/37EqW_CTt-.png")
          div(v-else @click="sign")
            img.rule-word-img(src="https://m.hellobike.com/resource/helloyun/08345/JJ8LaMe1nV.png")
          span.normal 已阅读并同意
          span.canClick(@click="goMember") 《哈啰会员服务协议》
          span.normal 与
          span.canClick(@click="goRenewal")  《自动续费协议》
</template>
<script>
import Picture from '@/components/picture';
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { env } from '@hb/hbridge';
import { commonGoLink } from '@/utils';
import { Storage } from '@/utils/storage';
import eventBus from '@/const/eventBus.js';
import Toast from '@/components/toast';

export default {
  components: {
    Lottie,
    Picture,
  },
  props: {
    info: {
      type: Object,
      default: null,
    },
    readSign: {
      type: Boolean,
      default: false,
    },
    isIndex: {
      type: Boolean,
      default: true,
    },
    unOpenShowCanBuy: {
      type: Boolean,
      required: true,
    },
    currentRideCard: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      ZeroMoney: 1,
      OneMonth: 2,
      ContinuousMonth: 3,
      classes: {
        show: false,
        fixed: false,
      },
      loadingPay: false,
      env,
      timer: null,
      timeout: null,
      allMonth: true,
      isNoSign: true,
      isOne: false,
      actived: 1,
      activedMoney: 0,
    };
  },
  computed: {
    openPrice() {
      if (this.allMonth) {
        return this.info.signInfoDTO ? this.info.signInfoDTO.firstSignPrice : '-';
      }
      return this.info.current || '-';
    },
  },
  watch: {
    readSign(val) {
      this.isNoSign = !val;
      eventBus.$emit('isNoSign', this.isNoSign);
    },
  },
  created() {
  },
  mounted() {
    if (this.$refs.anime) {
      this.$nextTick(() => {
        this.$refs.anime.lottie.setSpeed(1.3);
      });
    }
    const isNoSignStorge = Storage.getItem('isNoSign');
    if (isNoSignStorge === null) {
      this.isNoSign = true;
    } else {
      this.isNoSign = isNoSignStorge;
    }
    eventBus.$on('isNoSign', (msg) => {
      if (this.isIndex) {
        Storage.setItem('isNoSign', msg);
      }
      this.isNoSign = msg;
    });
  },
  destroyed() {
    this.timer = null;
    this.timeout = null;
  },
  methods: {
    optionChange(item) {
      this.actived = item;
      if (this.actived === this.ZeroMoney) {
        this.allMonth = true;
        this.activedMoney = 0;
      } else if (this.actived === this.ContinuousMonth) {
        this.activedMoney = this.info.signInfoDTO.firstSignPrice;
        this.allMonth = true;
      } else {
        this.activedMoney = this.info.current * 1;
        this.allMonth = false;
      }
      this.$emit('priceChange', this.actived);
    },
    buy(val) {
      if (val) {
        this.isOne = !this.isOne;
      }
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_0yuan_button',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (this.openPrice && this.openPrice !== '-') {
        // eslint-disable-next-line no-nested-ternary
        this.$emit('transTab', (this.actived !== 1 ? (this.allMonth ? 30 : 0) : 60), this.activedMoney);
        this.open();
      } else {
        Toast.show('暂无数据');
      }
    },
    open() {
      let ubtType;
      if (this.allMonth === 30) {
        ubtType = 2;
      } else {
        ubtType = 1;
      }
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_type_choose',
        categoryId: 'platform',
        businessInfo: {
          type: ubtType,
          typeandprice: `1&${this.info.signInfoDTO.firstSignPrice};2&${this.info.current}`,
        },
      });
      if (this.isNoSign) {
        this.$emit('isNoReadSign');
      } else if (this.info.showPopUpWindowType !== 1) {
        // eslint-disable-next-line no-nested-ternary
        this.$emit('open', null, this.allMonth ? ((this.actived === 1) ? 60 : 30) : 0, this.activedMoney);
      } else {
        this.$emit('openDialog');
      }
    },
    sign() {
      this.isNoSign = !this.isNoSign;
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_deal',
        categoryId: 'platform',
        businessInfo: {},
      });
      eventBus.$emit('isNoSign', this.isNoSign);
    },
    goRenewal() {
      commonGoLink(
        'https://m.hellobike.com/mf/spa/u_hywaxn/latest/MA2209193493443248207695231.html?activityCode=MA2209193493443248207695231',
        { isRuleLink: true },
      );
    },
    goMember() {
      commonGoLink(
        'https://m.hellobike.com/mf/spa/u_yewmjx/latest/MA2209283520078470713971794.html?activityCode=MA2209283520078470713971794',
        { isRuleLink: true },
      );
    },
    // 确定组件是否要固定在底部
    locate() {
      this.classes.fixed = true;
      this.classes.show = true;
    },
  },
};
</script>
<style lang="less" scoped>
.vip-button-new-container {
  background: #fff;
  box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.08);
  border-radius: 0.2rem 0.2rem 0 0;
  z-index: 3;
  padding: 0.16rem 0 0.34rem 0;
  height: 1.94rem;
  width: 100%;
  font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  position: fixed;
  bottom: 0;

  &.show {
    opacity: 1;
  }

  &.fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.25);
    border-radius: 0.12rem 0.12rem 0 0;
  }

  .trans-tab {
    // display: flex;

    .tab-options {
      margin: 0 auto;
      width: 3.45rem;
      height: 0.44rem;
      display: flex;
      justify-content: space-between;

      .options-item {
        width: 1.09rem;
        height: 0.44rem;
        border: 1px solid #f4f8fa;
        border-radius: 0.08rem;
        background: #f4f8fa;
        display: flex;
        align-items: center;
        justify-content: center;

        &.isActived {
          background: #fffcf7;
          border: 1px solid #ff9240;
        }

        .item-left {
          font-size: 0.12rem;
          color: #242729;

          span {
            &.red {
              color: #fa2a00;
            }
          }
        }

        .item-right {
          font-size: 0.18rem;
          color: #242729;
          margin-bottom: 0.03rem;
          font-family: "DIN Alternate Bold", sans-serif;

          &.red {
            color: #fa2a00;
            font-size: 0.2rem;
          }
        }
      }
    }

    .remarkContent {
      width: 100%;
      padding-left: 0.17rem;
      margin: 0.08rem 0 0.2rem 0;
      font-size: 0.12rem;
      color: #6c747a;

      .font-black {
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        color: #242729;
        font-weight: 700;
      }
    }

    .buy-button {
      margin: 0 auto;
      width: 3.45rem;
      height: 0.42rem;
      background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
      border-radius: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;

      .btn-left {
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        color: #fff;
        font-size: 0.18rem;
      }

      .btn-right {
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 0.12rem;
        text-decoration: line-through;
        margin-top: 0.02rem;
        margin-left: 0.05rem;
        color: #fff;
        opacity: 0.7;
      }
    }
  }

  .renewal-rules {
    margin-top: 0.08rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 400;
    color: #879099;
    text-align: center;
    width: 100%;
    display: flex;
    justify-content: center;

    * {
      overflow: visible;
      white-space: nowrap;
    }

    .canClick {
      color: #b16652;
    }

    img.rule-word-img {
      margin-right: 0.05rem;
      width: 0.16rem;
      height: 0.16rem;
    }
  }
}
</style>
